import { render, staticRenderFns } from "./publish.vue?vue&type=template&id=fbd95950&functional=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports